/**
 * Media URL helpers.
 *
 * Uploaded assets are stored by the backend and served from relative paths
 * such as `/api/storage/public/hero/video/<uuid>.mp4`. Those must be resolved
 * against REACT_APP_BACKEND_URL so they load no matter which host the SPA is
 * served from. Absolute URLs and data URIs are passed through untouched.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export const resolveMediaUrl = (url) => {
  const value = (url || '').trim();
  if (!value) return '';
  if (/^(https?:)?\/\//i.test(value) || value.startsWith('data:') || value.startsWith('blob:')) {
    return value;
  }
  if (value.startsWith('/api/')) {
    return `${BACKEND_URL}${value}`;
  }
  return value;
};

export const getVideoMimeType = (videoUrl) => {
  const normalized = (videoUrl || '').toLowerCase();
  if (normalized.includes('.mp4')) return 'video/mp4';
  if (normalized.includes('.webm')) return 'video/webm';
  if (normalized.includes('.ogv') || normalized.includes('.ogg')) return 'video/ogg';
  if (normalized.includes('.mov')) return 'video/quicktime';
  if (normalized.includes('.m4v')) return 'video/mp4';
  return 'video/mp4';
};
